import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiGetBankByNameRequest,
  DefaultApiGetBranchRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getBankByName = async (
  instance: AxiosInstance,
  params: DefaultApiGetBankByNameRequest
) => {
  return await userApiDefaultApiFactory(instance).getBankByName(params)
}

export const getBranch = async (
  instance: AxiosInstance,
  params: DefaultApiGetBranchRequest
) => {
  return await userApiDefaultApiFactory(instance).getBranch(params)
}

// Do Not Remove this line ===@import api client===
